import * as actionTypes from '../constants/actionType';
import * as apiActions from './apiActions';
import * as apiValues from '../constants/apiValues';
import * as helpers from '../helpers';

const SEARCH_MATCH_LIMIT = 200;

/** Server-side _contains queries (same pattern as header autocomplete). */
const SEARCH_FIELD_CONFIG = {
  project: {
    endpoint: apiValues.nref.project.endpoint,
    fieldsUsed: apiValues.nref.project.fieldsUsed,
    fieldNames: ['Title', 'What Description', 'Why Description', 'Intro Description', 'Description', 'Location Description', 'Neighborhoods'],
    sort: 'LastSave:desc',
    populateProgram: true,
  },
  news: {
    endpoint: apiValues.nref.news.endpoint,
    fieldsUsed: apiValues.nref.news.fieldsUsed,
    fieldNames: ['Title', 'Description'],
    sort: 'NewsDate:desc',
    populateProgram: true,
  },
  event: {
    endpoint: apiValues.nref.event.endpoint,
    fieldsUsed: apiValues.nref.event.fieldsUsed,
    fieldNames: ['Title', 'Content', 'Location Description'],
    sort: 'EventDate:desc',
    populateProgram: true,
  },
  program: {
    endpoint: apiValues.nref.program.endpoint,
    fieldsUsed: apiValues.nref.program.fieldsUsed,
    fieldNames: ['Title', 'Short Description', 'Long Description', 'Short Description Small'],
    sort: 'Title:asc',
  },
  pageContentDetail: {
    endpoint: apiValues.nref.pageContentDetail.endpoint,
    fieldsUsed: apiValues.nref.pageContentDetail.fieldsUsed,
    fieldNames: ['Title', 'Short Description', 'Long Description', 'Short Description Small'],
    sort: 'Title:asc',
    populateProgram: true,
  },
};

function fetchSearchCollection(query, config) {
  const trimmed = (query || '').trim();
  const opts = {
    ...apiValues.SEARCH_RESULT_QUERY,
    ...(config.populateProgram ? apiValues.SEARCH_RESULT_PROGRAM_POPULATE : {}),
    _sort: config.sort,
    _limit: SEARCH_MATCH_LIMIT,
  };
  return helpers.multiFieldContainsQuery(trimmed, config.endpoint, config.fieldNames, 'id', opts);
}

function matchesPageContentDetailQuery(item, query) {
  if (!query) return true;
  const q = query.toLowerCase();
  return (
    (item.title && item.title.toLowerCase().includes(q)) ||
    (item.shortDescription && item.shortDescription.toLowerCase().includes(q)) ||
    (item.longDescription && item.longDescription.toLowerCase().includes(q)) ||
    (item.shortDescriptionSmall && item.shortDescriptionSmall.toLowerCase().includes(q))
  );
}


// Action Creators
export const setQuery = query => dispatch => {
  dispatch({
    type: actionTypes.SEARCH_SET_QUERY,
    data: query,
  });
};
export const setTagQueryActionCreator = (tag) => dispatch => {
  dispatch({
    type: actionTypes.SEARCH_SET_TAG_QUERY,
    data: tag,
  });
};
export const setProgram = program => dispatch => {
  dispatch({
    type: actionTypes.SEARCH_SET_PROGRAMS,
    data: program,
  });
};
export const setTypes = types => dispatch => {
  dispatch({
    type: actionTypes.SEARCH_SET_TYPES,
    data: types,
  });
};


export const setTagQuery = tag => dispatch => {
  apiActions.loadEndpoint(apiValues.nref.tag.endpoint, tag)
    .then(results => {
      const rows = Array.isArray(results) ? results : (results ? [results] : []);
      let tags = apiActions.arraySelectCamelCaseKeys(rows, apiValues.nref.tag.fieldsUsed);

      if(!tags[0]){
        return;
      }
      dispatch(setTagQueryActionCreator(tags[0]));
      dispatch(initSearchWithTags(tag));
    })
    .catch(err => {
      console.error(err);
    });
};


//News
export const loadNewsStart = () => {
  return {
    type: actionTypes.SEARCH_NEWS_LOAD_START,
  };
};
export const loadNewsFail = error => {
  console.error(error);
  return {
    type: actionTypes.SEARCH_NEWS_LOAD_FAIL,
    error,
  };
};
export const loadNewsSuccess = data => {
  return {
    type: actionTypes.SEARCH_NEWS_LOAD_SUCCESS,
    data,
  };
};
export const loadNews = (query = '') => dispatch => {
  dispatch(loadNewsStart());

  return fetchSearchCollection(query, SEARCH_FIELD_CONFIG.news)
    .then(results => {
      dispatch(loadNewsSuccess(apiActions.arraySelectCamelCaseKeys(results || [], SEARCH_FIELD_CONFIG.news.fieldsUsed)));
    })
    .catch(err => {
      dispatch(loadNewsFail(err));
    });
};
export const loadNewsWithTag = selectedTag => dispatch => {
  dispatch(loadNewsStart());

  //get news
  apiActions.loadEndpointByFilters(apiValues.nref.news.endpoint, {Tags_in: selectedTag, '_sort': 'NewsDate:DESC'})
    .then(results => {
      dispatch(loadNewsSuccess(apiActions.arraySelectCamelCaseKeys(results, apiValues.nref.news.fieldsUsed)));
    })
    .catch(err => {
      dispatch(loadNewsFail(err));
    });
};


//Events
export const loadEventsStart = () => {
  return {
    type: actionTypes.SEARCH_EVENTS_LOAD_START,
  };
};
export const loadEventsFail = error => {
  console.error(error);
  return {
    type: actionTypes.SEARCH_EVENTS_LOAD_FAIL,
    error,
  };
};
export const loadEventsSuccess = data => {
  return {
    type: actionTypes.SEARCH_EVENTS_LOAD_SUCCESS,
    data,
  };
};
export const loadEvents = (query = '') => dispatch => {
  dispatch(loadEventsStart());

  return fetchSearchCollection(query, SEARCH_FIELD_CONFIG.event)
    .then(results => {
      dispatch(loadEventsSuccess(apiActions.arraySelectCamelCaseKeys(results || [], SEARCH_FIELD_CONFIG.event.fieldsUsed)));
    })
    .catch(err => {
      dispatch(loadEventsFail(err));
    });
};
export const loadEventsWithTag = selectedTag => dispatch => {
  dispatch(loadEventsStart());

  //get events
  apiActions.loadEndpointByFilters(apiValues.nref.event.endpoint, {Tags_in: selectedTag})
    .then(results => {
      dispatch(loadEventsSuccess(apiActions.arraySelectCamelCaseKeys(results, apiValues.nref.event.fieldsUsed)));
    })
    .catch(err => {
      dispatch(loadEventsFail(err));
    });
};


//Projects
export const loadProjectsStart = () => {
  return {
    type: actionTypes.SEARCH_PROJECTS_LOAD_START,
  };
};
export const loadProjectsFail = error => {
  console.error(error);
  return {
    type: actionTypes.SEARCH_PROJECTS_LOAD_FAIL,
    error,
  };
};
export const loadProjectsSuccess = data => {
  return {
    type: actionTypes.SEARCH_PROJECTS_LOAD_SUCCESS,
    data,
  };
};
export const loadProjects = (query = '') => dispatch => {
  dispatch(loadProjectsStart());

  return fetchSearchCollection(query, SEARCH_FIELD_CONFIG.project)
    .then(results => {
      dispatch(loadProjectsSuccess(apiActions.arraySelectCamelCaseKeys(results || [], SEARCH_FIELD_CONFIG.project.fieldsUsed)));
    })
    .catch(err => {
      dispatch(loadProjectsFail(err));
    });
};
export const loadProjectsWithTag = selectedTag => dispatch => {
  dispatch(loadProjectsStart());

  //get projects
  apiActions.loadEndpointByFilters(apiValues.nref.project.endpoint, {Tags_in: selectedTag})
    .then(results => {
      dispatch(loadProjectsSuccess(apiActions.arraySelectCamelCaseKeys(results, apiValues.nref.project.fieldsUsed)));
    })
    .catch(err => {
      dispatch(loadProjectsFail(err));
    });
};


//Programs
export const loadProgramsStart = () => {
  return {
    type: actionTypes.SEARCH_PROGRAMS_LOAD_START,
  };
};
export const loadProgramsFail = error => {
  console.error(error);
  return {
    type: actionTypes.SEARCH_PROGRAMS_LOAD_FAIL,
    error,
  };
};
export const loadProgramsSuccess = data => {
  return {
    type: actionTypes.SEARCH_PROGRAMS_LOAD_SUCCESS,
    data,
  };
};
export const loadPrograms = (query = '') => dispatch => {
  dispatch(loadProgramsStart());

  return fetchSearchCollection(query, SEARCH_FIELD_CONFIG.program)
    .then(results => {
      dispatch(loadProgramsSuccess(apiActions.arraySelectCamelCaseKeys(results || [], SEARCH_FIELD_CONFIG.program.fieldsUsed)));
    })
    .catch(err => {
      dispatch(loadProgramsFail(err));
    });
};
export const loadProgramFilterOptions = () => dispatch => {
  return apiActions.loadEndpoint(apiValues.nref.program.endpoint, null, {
    ...apiValues.FILTER_OPTION_QUERY,
    _sort: 'Title:asc',
  })
    .then(results => {
      const data = apiActions.arraySelectCamelCaseKeys(results || [], apiValues.FILTER_OPTION_FIELDS);
      dispatch({
        type: actionTypes.SEARCH_PROGRAM_OPTIONS_LOAD_SUCCESS,
        data,
      });
      return data;
    })
    .catch(err => {
      console.error(err);
      return [];
    });
};
export const loadProgramsWithTag = selectedTag => dispatch => {
  dispatch(loadProgramsStart());

  //get programs
  apiActions.loadEndpointByFilters(apiValues.nref.program.endpoint, {RelatedTag_in: selectedTag})
    .then(results => {
      dispatch(loadProgramsSuccess(apiActions.arraySelectCamelCaseKeys(results, apiValues.nref.program.fieldsUsed)));
    })
    .catch(err => {
      dispatch(loadProgramsFail(err));
    });
};


//PageContentDetails
export const loadPageContentDetailsStart = () => {
  return {
    type: actionTypes.SEARCH_PAGECONTENTDETAILS_LOAD_START,
  };
};
export const loadPageContentDetailsFail = error => {
  console.error(error);
  return {
    type: actionTypes.SEARCH_PAGECONTENTDETAILS_LOAD_FAIL,
    error,
  };
};
export const loadPageContentDetailsSuccess = data => {
  return {
    type: actionTypes.SEARCH_PAGECONTENTDETAILS_LOAD_SUCCESS,
    data,
  };
};
export const loadPageContentDetails = (query = '') => dispatch => {
  dispatch(loadPageContentDetailsStart());

  return fetchSearchCollection(query, SEARCH_FIELD_CONFIG.pageContentDetail)
    .then(results => {
      dispatch(loadPageContentDetailsSuccess(apiActions.arraySelectCamelCaseKeys(results || [], SEARCH_FIELD_CONFIG.pageContentDetail.fieldsUsed)));
    })
    .catch(err => {
      dispatch(loadPageContentDetailsFail(err));
    });
};
export const loadPageContentDetailsWithTag = selectedTag => dispatch => {
  dispatch(loadPageContentDetailsStart());

  //get pageContentDetails
  apiActions.loadEndpointByFilters(apiValues.nref.pageContentDetail.endpoint, {Tags_in: selectedTag})
    .then(results => {
      dispatch(loadPageContentDetailsSuccess(apiActions.arraySelectCamelCaseKeys(results, apiValues.nref.pageContentDetail.fieldsUsed)));
    })
    .catch(err => {
      dispatch(loadPageContentDetailsFail(err));
    });
};


//General
export const initSearch = (query = '') => dispatch => {
  const q = (query || '').trim();
  if(!q){
    dispatch(loadNewsSuccess([]));
    dispatch(loadEventsSuccess([]));
    dispatch(loadProgramsSuccess([]));
    dispatch(loadProjectsSuccess([]));
    dispatch(loadPageContentDetailsSuccess([]));
    dispatch({
      type: actionTypes.SEARCH_SET_QUERY,
      data: '',
    });
    return Promise.resolve();
  }
  dispatch({
    type: actionTypes.SEARCH_SET_QUERY,
    data: q,
  });
  return Promise.all([
    dispatch(loadNews(q)),
    dispatch(loadEvents(q)),
    dispatch(loadPrograms(q)),
    dispatch(loadProjects(q)),
    dispatch(loadPageContentDetails(q)),
  ]);
};
export const initSearchWithTags = selectedTag => dispatch => {
  console.log(selectedTag);
  dispatch(loadNewsWithTag(selectedTag));
  dispatch(loadEventsWithTag(selectedTag));
  dispatch(loadProgramsWithTag(selectedTag));
  dispatch(loadProjectsWithTag(selectedTag));
  dispatch(loadPageContentDetailsWithTag(selectedTag));
};
//todo: redo this function so it is more generic / simple
export const filterResult = state => {
  state.filterQuery = state.filterQuery || '';
  const query = state.filterQuery.toLowerCase();
  const types = state.filterType;
  const filterProgram = state.filterProgram;

  const projects = state.projects;
  const news = state.news;
  const programs = state.programs;
  const events = state.events;
  const pageContentDetails = state.pageContentDetails;

  let projectResult = [];
  let newsResult = [];
  let eventResult = [];
  let programResult = [];
  let pageContentDetailResult = [];
  let total = 0;


  // Types selected
  if(types.length > 0){
    // Filter projects
    if(types.includes('project')){
      if(filterProgram.length > 0){
        projectResult = projects.filter(project => {
          if(!project.program){
            return false;
          }
          return filterProgram.includes(project.program.id);
        });
        if(query !== ''){
          projectResult = projectResult.filter(project => {
            if(project.title && project.title.toLowerCase().includes(query)){
              return true;
            }
            if(
              project.description &&
              project.description.toLowerCase().includes(query)
            ){
              return true;
            }
            return false;
          });
        }
        total = projectResult.length;
      }else{
        if(query !== ''){
          projectResult = projects.filter(project => {
            if(project.title && project.title.toLowerCase().includes(query)){
              return true;
            }
            if(
              project.description &&
              project.description.toLowerCase().includes(query)
            ){
              return true;
            }
            return false;
          });
        }else{
          projectResult = projects;
        }
        total = projectResult.length;
      }
    }

    // Filter programs
    if(types.includes('program')){
      if(filterProgram.length > 0){
        programResult = programs.filter(program =>
          filterProgram.includes(program.id),
        );
        if(query !== ''){
          programResult = programResult.filter(program => {
            if(program.title && program.title.toLowerCase().includes(query)){
              return true;
            }
            if(
              program.shortDescription &&
              program.shortDescription.toLowerCase().includes(query)
            ){
              return true;
            }
            return false;
          });
        }
        total += programResult.length;
      }else{
        if(query !== ''){
          programResult = programs.filter(program => {
            if(program.title && program.title.toLowerCase().includes(query)){
              return true;
            }
            if(
              program.shortDescription &&
              program.shortDescription.toLowerCase().includes(query)
            ){
              return true;
            }
            return false;
          });
        }else{
          programResult = programs;
        }
        total += programResult.length;
      }
    }

    // Filter events
    if(types.includes('event')){
      if(filterProgram.length > 0){
        eventResult = events.filter(event =>
          filterProgram.includes(event.program.id),
        );
        if(query !== ''){
          eventResult = eventResult.filter(event => {
            if(event.title.toLowerCase().includes(query)) return true;

            if(event.content && event.content.Contents){
              return event.content.Contents.toLowerCase().includes(query);
            }
            return false;
          });
        }
        total += eventResult.length;
      }else{
        if(query !== ''){
          eventResult = events.filter(event => {
            if(event.title.toLowerCase().includes(query)) return true;

            if(event.content && event.content.Contents){
              return event.content.Contents.toLowerCase().includes(query);
            }
            return false;
          });
        }else{
          eventResult = events;
        }
        total += eventResult.length;
      }
    }

    // Filter news
    if(types.includes('news')){
      if(filterProgram.length > 0){
        newsResult = news.filter(item =>
          filterProgram.includes(item.program.id),
        );
        if(query !== ''){
          newsResult = newsResult.filter(item => {
            if(item.title && item.title.toLowerCase().includes(query)){
              return true;
            }
            if(
              item.description &&
              item.description.toLowerCase().includes(query)
            ){
              return true;
            }
            return false;
          });
        }
        total += newsResult.length;
      }else{
        if(query !== ''){
          newsResult = news.filter(item => {
            if(item.title && item.title.toLowerCase().includes(query)){
              return true;
            }
            if(
              item.description &&
              item.description.toLowerCase().includes(query)
            ){
              return true;
            }
            return false;
          });
        }else{
          newsResult = news;
        }
        total += newsResult.length;
      }
    }

    // Filter pageContentDetails
    if(types.includes('other')){
      if(filterProgram.length > 0){
        pageContentDetailResult = pageContentDetails.filter(item => filterProgram.includes(item.program.id));
        if(query !== '')
          pageContentDetailResult = pageContentDetails.filter(item => matchesPageContentDetailQuery(item, query));
        total += pageContentDetailResult.length;
      }else{
        if(query !== '')
          pageContentDetailResult = pageContentDetails.filter(item => matchesPageContentDetailQuery(item, query));
        else pageContentDetailResult = pageContentDetails;

        total += pageContentDetailResult.length;
      }
    }
  }else{
    // Filter projects
    if(filterProgram.length > 0){
      projectResult = projects.filter(project =>
        filterProgram.includes(project.program.id),
      );
      if(query !== ''){
        projectResult = projectResult.filter(project => {
          if(project.title && project.title.toLowerCase().includes(query)){
            return true;
          }
          if(
            project.description &&
            project.description.toLowerCase().includes(query)
          ){
            return true;
          }
          return false;
        });
      }
      total = projectResult.length;
    }else{
      if(query !== ''){
        projectResult = projects.filter(project => {
          if(project.title && project.title.toLowerCase().includes(query)){
            return true;
          }
          if(
            project.description &&
            project.description.toLowerCase().includes(query)
          ){
            return true;
          }
          return false;
        });
      }else{
        projectResult = projects;
      }
      total = projectResult.length;
    }

    // Filter programs
    if(filterProgram.length > 0){
      programResult = programs.filter(program =>
        filterProgram.includes(program.id),
      );
      if(query !== ''){
        programResult = programResult.filter(program => {
          if(program.title && program.title.toLowerCase().includes(query)){
            return true;
          }
          if(
            program.shortDescription &&
            program.shortDescription.toLowerCase().includes(query)
          ){
            return true;
          }
          return false;
        });
      }
      total += programResult.length;
    }else{
      if(query !== ''){
        programResult = programs.filter(program => {
          if(program.title && program.title.toLowerCase().includes(query)){
            return true;
          }
          if(
            program.shortDescription &&
            program.shortDescription.toLowerCase().includes(query)
          ){
            return true;
          }
          return false;
        });
      }else{
        programResult = programs;
      }
      total += programResult.length;
    }

    // Filter events
    if(filterProgram.length > 0){
      eventResult = events.filter(event =>
        filterProgram.includes(event.program.id),
      );
      if(query !== ''){
        eventResult = eventResult.filter(event => {
          if(event.title.toLowerCase().includes(query)) return true;

          if(event.content && event.content.Contents){
            return event.content.Contents.toLowerCase().includes(query);
          }
          return false;
        });
      }
      total += eventResult.length;
    }else{
      if(query !== ''){
        eventResult = events.filter(event => {
          if(event.title.toLowerCase().includes(query)) return true;

          if(event.content && event.content.Contents){
            return event.content.Contents.toLowerCase().includes(query);
          }
          return false;
        });
      }else{
        eventResult = events;
      }
      total += eventResult.length;
    }

    // Filter news
    if(filterProgram.length > 0){
      newsResult = news.filter(item =>
        item.program && filterProgram.includes(item.program.id),
      );
      if(query !== ''){
        newsResult = newsResult.filter(item => {
          if(item.title && item.title.toLowerCase().includes(query)){
            return true;
          }
          if(
            item.description &&
            item.description.toLowerCase().includes(query)
          ){
            return true;
          }
          return false;
        });
      }
      total += newsResult.length;
    }else{
      if(query !== ''){
        newsResult = news.filter(item => {
          if(item.title && item.title.toLowerCase().includes(query)){
            return true;
          }
          if(
            item.description &&
            item.description.toLowerCase().includes(query)
          ){
            return true;
          }
          return false;
        });
      }else{
        newsResult = news;
      }
      total += newsResult.length;
    }

    // Filter pageContentDetails
    if(filterProgram.length > 0){
      pageContentDetailResult = pageContentDetails.filter(item => filterProgram.includes(item.program.id));
      if(query !== '')
        pageContentDetailResult = pageContentDetails.filter(item => matchesPageContentDetailQuery(item, query));
      total += pageContentDetailResult.length;
    }else{
      if(query !== '')
        pageContentDetailResult = pageContentDetails.filter(item => matchesPageContentDetailQuery(item, query));
      else pageContentDetailResult = pageContentDetails;
      total += pageContentDetailResult.length;
    }
  }

  programResult = programResult.map(program => {
    program.type = 'program';
    return program;
  });

  projectResult = projectResult.map(project => {
    project.type = 'project';
    return project;
  });

  newsResult = newsResult.map(item => {
    item.type = 'news';
    return item;
  });

  eventResult = eventResult.map(event => {
    event.type = 'event';
    return event;
  });

  pageContentDetailResult = pageContentDetailResult.map(pageContentDetail => {
    pageContentDetail.type = 'pageContentDetail';
    return pageContentDetail;
  });

  return {
    programResult,
    projectResult,
    newsResult,
    eventResult,
    total,
    pageContentDetailResult,
  };
};
